<template>
  <div>
    <form ref="form" v-kendo-validator @submit.prevent="addClient()">
      <div class="page-header d-flex w-100">
        <div class="title-col d-flex w-50">
          <span class="title-icon">
            <b-icon-folder-fill></b-icon-folder-fill>
          </span>
          <span class="title-text" v-if="add">Add Client</span>
          <span class="title-text" v-if="!add">Update Client</span>
        </div>
        <div class="text-right ml-auto">
          <button class="k-button k-green ml-2" v-if="add">Add</button>
          <button class="k-button k-green ml-2" v-if="!add">Update</button>
          <!-- <button class="k-button k-primary ml-2" v-if="!add">Update</button> -->
          <!-- <button class="k-button k-gray ml-2" @click="clearAll">Clear</button> -->
          <button class="k-button k-gray ml-2" @click="goToListPage">Cancel</button>
        </div>
      </div>
      <div class="page-body">
        <div class="bg-white p-4">
          <div class="row">
            <!-- <div v-show="!add" class="col-3 form-group">
              <label>ID</label>
              <k-input :name="'id'" :style="{ width:'100%' }" id="id" v-model="id" disabled="true" />
            </div> -->
            <div class="col-3 form-group">
              <label>Name<span style="color: red;">*</span></label>
              <k-input
                :name="'Name'"
                :style="{ width:'100%' }"
                :required="true"
                id="name"
                v-model="name"
              />
            </div>

            <div class="col-3 form-group">
              <label>
                Contact Person
                <span style="color: red;">*</span>
              </label>
              <k-input
                :name="'Contact Person'"
                :style="{ width:'100%' }"
                :required="true"
                id="contactPerson"
                v-model="contactPerson"
              />
            </div>

            <div class="col-3 form-group">
              <label>
                Contact No
                <span style="color: red;">*</span>
              </label>
              <k-input
                :name="'Contact No'"
                :style="{ width:'100%' }"
                :required="true"
                type="number"
                id="contactNo"
                v-model="contactNo"
              />
            </div>

          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("user");
export default {
   data: function() {
     return {
       add: this.$route.params.add,
       name:null,
       contactPerson: null,
       contactNo: null,
     }
   },
   computed: {
     ...mapState(["client"])
   },
   mounted() {
     if(!this.$route.params.add) {
      this.name = this.client.name;
      this.contactPerson=this.client.contactPerson;
      this.contactNo=this.client.contactNo;
     }
   },
   methods: {
    goToListPage: function() {
      this.$store.dispatch("loadClients").then(() => {
      this.$router.push({ name: "ClientManagement"});
    });
    },
    addClient() {
      if (this.name && this.contactPerson && this.contactNo) {
        this.clientData = {
          Name: this.name,
          ContactPerson: this.contactPerson,
          ContactNo: this.contactNo,
        };
        if (this.add) {
          this.$store.dispatch("user/addClients", this.clientData).then(() => {
            this.goToListPage();
            this.clearAll();
          });
        } 
        else {
          this.clientData.id=this.client.id;
          this.$store.dispatch("user/updateClient", this.clientData).then(() => {
            this.goToListPage();
            this.clearAll();
          });
        }
      }
    },
    clearAll: function() {
      this.name = null;
      this.contactPerson=null;
      this.contactNo=null;
    },
  }, 
}
</script>